import React, { Component } from 'react'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup
} from '../modal-form/modal-form'

import collectionChangeHandler from '../../helpers/collection-change-handler'

import {
  CollectionButton
} from '../buttons'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

class WorkTrackerFilterModal extends Component {
  radioButtons (resources) {
    const {
      fields: {
        resourceId
      },
      resourceNameGenerator
    } = this.props

    return (
      <div>
        {resources.map((resource) => (
          <label key={resource.id}>
            <input
              type='radio'
              {...resourceId}
              value={resource.id}
              checked={
                resourceId.value &&
                  resourceId.value.toString() === resource.id.toString()
              }
            />
            <span className='indicator' />
            {formatResourceName(resource, resourceNameGenerator)}
          </label>
        ))}
      </div>
    )
  }

  checkboxes (resources) {
    const {
      fields: {
        resourceId
      },
      resourceNameGenerator
    } = this.props

    return (
      <div>
        {resources.map((resource, index) => {
          if (!resource) return null

          return (
            <label htmlFor={resource.id} key={resource.id}>
              <input
                type='checkbox'
                value={resource.id}
                id={resource.id}
                checked={(resourceId.value && resourceId.value.indexOf(resource.id) >= 0)}
                onChange={collectionChangeHandler(resourceId)}
              />
              <span className='indicator' />
              {formatResourceName(resource, resourceNameGenerator)}
            </label>
          )
        })}
      </div>
    )
  }

  render () {
    const {
      fields: {
        resourceId
      },

      contractedServices,
      otherServices,
      resourceNameGenerator,

      handleSubmit,
      handleClose,
      modalTitle,
      submitButtonText,

      hasNextPage,
      onLoadNextPage
    } = this.props

    return (
      <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName='work-orders-create-container'
      >
        <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
          <ModalFormRow>
            <ModalFormBlock>
              <CheckboxGroup title='Contracted'>
                {contractedServices && this.checkboxes(contractedServices)}
                {contractedServices && contractedServices.length === 0 &&
                  <p className='none'>No Contracted Services found.</p>}
              </CheckboxGroup>
            </ModalFormBlock>
          </ModalFormRow>
          <ModalFormRow>
            <ModalFormBlock>
              <CheckboxGroup title='Other'>
                {otherServices && this.checkboxes(otherServices)}
                {otherServices && otherServices.length === 0 &&
                  <p className='none'>No Services found.</p>}
              </CheckboxGroup>
            </ModalFormBlock>
          </ModalFormRow>

          {hasNextPage &&
            <CollectionButton onClick={onLoadNextPage}>See more {resourceName}s...</CollectionButton>}

          <ModalFormRow>
            <ModalFormBlock submitButton>
              <button type='submit'>{submitButtonText || 'Submit'}</button>
            </ModalFormBlock>
          </ModalFormRow>
        </ModalForm>
      </BaseModal>
    )
  }
}

function formatResourceName (resource, resourceNameGenerator) {
  if (resourceNameGenerator) {
    return resourceNameGenerator(resource)
  } else {
    return resource.name
  }
}

export default WorkTrackerFilterModal



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-tracker-service-filter-modal.js